import { useState } from "react"

interface UseInstructionFilterReturn {
  filterDrawerOpen: boolean
  setFilterDrawerOpen: (open: boolean) => void
}

export const useInstructionFilter = (): UseInstructionFilterReturn => {
  const [filterDrawerOpen, setFilterDrawerOpen] = useState<boolean>(false)

  return {
    filterDrawerOpen,
    setFilterDrawerOpen,
  }
}
